<div #main class="main" *ngIf="!mobileMode">
  <div #titleGroup class="title">
    <h3>{{ title | translate}}</h3>
    <p>{{ subTitle | translate}}</p>
  </div>
  <div class="content">

    <div class="menu">

      <div class="subTitle" *ngFor="let item of data">

        <div class="picto">
          <img [src]="item.selected ? item.iconActived : item.iconDeactived" alt="item.title + '_icon'">
        </div>

        <div class="textContent">
          <h4 [ngClass]="item.selected ? 'selected' : ''" (click)="moveImage(item)">{{ item.title | translate}}</h4>
          <p *ngIf="item.selected" @fadeText>{{ item.description | translate}}</p>
        </div>

      </div>

    </div>

    <div #imagesList class="images" [@moveImage]="{value: state, params: {blockHeight: height}}">
      <div *ngIf="type === 'images'">
        <img *ngFor="let item of data" [src]="item.image" [alt]="item.title + '_image'">
      </div>
      <div *ngIf="type === 'videos'">
        <video class="carouselVideoItem" loop muted playsinline preload="auto" [poster]="'assets/images/fallback/casourel/' + item.name + '.jpg'" *ngFor="let item of data">
          <source [src]="'https://d2z7yiz3wla4oq.cloudfront.net/videos/' + item.name + '.webm'" type="video/webm">
          <source [src]="'https://d2z7yiz3wla4oq.cloudfront.net/videos/' + item.name + '.mp4'" type="video/mp4">
        </video>
      </div>
    </div>

  </div>

</div>

<div class="mainMobile" *ngIf="mobileMode">

  <div class="title">
    <h3>{{ title | translate }}</h3>
    <p>{{ subTitle | translate }}</p>
  </div>

  <div class="content" *ngFor="let item of data">

    <img *ngIf="type === 'images'" [src]="item.image" alt="item.title + '_image'">

    <div *ngIf="type === 'videos'" class="video" (click)="playVideo($event, item)">
      <svg [ngClass]="item.selected ? 'hide' : ''" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="30" cy="30" r="30" fill="#504F4F"/>
        <path d="M41.8176 29.2294L24.3756 40.5169L23.3214 19.7679L41.8176 29.2294Z" fill="white"/>
      </svg>
      <video class="carouselVideoItem" loop muted playsinline preload="auto" [poster]="'assets/images/fallback/casourel/' + item.name + '.jpg'" data-wf-ignore="true" data-object-fit="cover">
        <source [src]="'https://d2z7yiz3wla4oq.cloudfront.net/videos/' + item.name + '.mp4'" type="video/mp4" data-wf-ignore="true">
        <source [src]="'https://d2z7yiz3wla4oq.cloudfront.net/videos/' + item.name + '.webm'" type="video/webm" data-wf-ignore="true">
      </video>
    </div>


    <div class="details">

      <div class="picto">
        <img [src]="item.iconActived" alt="item.title + '_icon'">
      </div>

      <div class="text">
        <h4>{{ item.title | translate}}</h4>
        <p>{{ item.description | translate}}</p>
      </div>

    </div>
  </div>
</div>
